import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74485472"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw600 right-btn" }, "更换网点", -1))
const _hoisted_2 = { class: "network-wrap" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "address xag-flex van-hairline--bottom" }
const _hoisted_5 = { class: "addr" }
const _hoisted_6 = { class: "xag-flex" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "txt" }, "导航", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "txt" }, "电话", -1))
const _hoisted_9 = { class: "map-div" }

import { getMap } from '@/utils/maptalkFactory'
import { useRouter } from 'vue-router'
import { Map, VectorLayer, Marker, Layer, Coordinate } from 'maptalks'
import { ref, onMounted, withDefaults, computed } from 'vue'
import { useMalfunctionRepairStore } from '@/compositions/malfunction-repair/index'

import appHost from '@/utils/app'
import BlockkWrapper from '../block-wrap.vue'
import getMapSiteInfo from '@/compositions/map/index'
import IconArrowRightWrap from '@/components/icon/IconArrowRightWrap.vue'
import { MalfunctionRepairServiceOrderNetworkItem } from '@/types/malfunction-repair'

export default /*#__PURE__*/_defineComponent({
  __name: 'detail-network-block',
  props: {
    warehouse: { default: () => null },
    status: null,
    guid: null,
    isUav: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { warehouse: MalfunctionRepairServiceOrderNetworkItem, status: string, guid: string, isUav: boolean };

const $router = useRouter()


const box = ref<HTMLElement>()
const { getOrderApplyInfo } = useMalfunctionRepairStore()

let { mapZoom, mapCenter } = getMapSiteInfo()
let map: Map = null
let layer: Layer = null
let marker: Marker = null
function initMap() {
  map = getMap(box.value, {
    center: mapCenter.value,
    zoom: mapZoom.value,
    attribution: false,
    tidituType: '地形注记',
  })
  layer = new VectorLayer(Date.now().toString()).addTo(map)
  const { lat, lng } = props.warehouse
  setMarker([lng, lat])
}
function setMarker(center: number[]) {
  if (!marker) {
    marker = new Marker(center, {
      id: Date.now().toString(),
      editable: false,
      interactive: false,
      symbol: {
        markerFile: '/images/icon_weizhi.png',
        markerWidth: 40,
        markerHeight: 40,
        scale: 1,
        textFill: 'rgba(255,255,255,1)',
        textSize: 12,
        textWeight: 500,
        textHaloFill: '#222',
        textHaloRadius: 1,
        textHaloOpacity: 0.6,
      },
    })
    marker.addTo(layer)
  }
  marker.setCoordinates(center)
  map.setCenter(new Coordinate(center))
}
const addressStr = computed(() => {
  const { province, city, area, address } = props.warehouse
  return `${province === city ? '' : province}${city || ''}${area || ''}${address}`
})

const onCallPoint = () => {
  const phone = props.warehouse.contact_phone || ''
  appHost.postCallPhone(phone.trim(), props.warehouse?.name)
}
const onNavigatePoint = () => {
  const { address = '', lng: lng = '0', lat: lat = '0' } = props.warehouse
  appHost.postMapNavigation({ address, lng: Number(lng), lat: Number(lat) })
}

const canChangeNetworkStatus = ['WAIT_RECEIVE']
const canChangeNetWork = computed(() => {
  let status = props.status
  return canChangeNetworkStatus.indexOf(status) !== -1
})
const changeNetwork = async () => {
  let query: Record<string, string> = {}
  try {
    const data = await getOrderApplyInfo(props.guid)
    console.log('data', data)
    query.sn = data.serial_number
    query.guid = data.logs[0]?.guid || ''
    query.orderGuid = props.guid
    query.is_boom = String(data.is_boom === 1)
    query.selectedWarehouseGuid = props.warehouse.guid
    query.from = 'order-detail'
    if (props.isUav) {
      query.is_uav = '1'
    }
    console.log('query', query)
  } catch (error) {
    console.log('error', error)
  }
  // addServiceOrderKeepAlive()
  setTimeout(() => {
    $router.push({
      name: 'malfunction-repair-network-list',
      query,
    })
  }, 100)
}
onMounted(() => {
  initMap()
  void getOrderApplyInfo(props.guid)
})

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createBlock(BlockkWrapper, { title: "报修网点" }, _createSlots({
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(__props.warehouse.name), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(addressStr)), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "oper-btn",
              onClick: onNavigatePoint
            }, [
              _createVNode(_component_van_icon, {
                size: "20px",
                name: "/images/icon_daohang.svg"
              }),
              _hoisted_7
            ]),
            _createElementVNode("div", {
              class: "oper-btn",
              style: {"margin-left":"16px"},
              onClick: onCallPoint
            }, [
              _createVNode(_component_van_icon, {
                size: "20px",
                name: "/images/icon_dianhua.svg"
              }),
              _hoisted_8
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            ref_key: "box",
            ref: box,
            class: "map-box"
          }, null, 512)
        ])
      ])
    ]),
    _: 2
  }, [
    (_unref(canChangeNetWork))
      ? {
          name: "right",
          fn: _withCtx(() => [
            _createVNode(IconArrowRightWrap, { onClick: changeNetwork }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1024))
}
}

})